'use client';

import Image from 'next/image';
import { ToastContainer } from 'react-toastify';
import './toast-v4.scss';

// Icon assets exported from Figma (node 4050:539); size set in toast-v4.scss.
const ICONS: Record<string, {
  src: string;
}> = {
  info: {
    src: '/assets/icons/toast-info.svg'
  },
  success: {
    src: '/assets/icons/toast-success.svg'
  },
  error: {
    src: '/assets/icons/toast-error.svg'
  },
  warning: {
    src: '/assets/icons/toast-warning.svg'
  }
};

/**
 * App-wide toast container styled to the v4 design (Figma node 4050:539).
 * Pass `rtl` for Arabic so the icon/text order and text direction flip.
 */
const ToastV4Container = ({
  rtl
}: {
  rtl: boolean;
}) => <ToastContainer className="toast-v4-container" toastClassName="toast-v4" position="bottom-center" rtl={rtl} hideProgressBar closeButton={false} closeOnClick icon={({
  type
}) => {
  const icon = ICONS[type] ?? ICONS.info;
  return <Image src={icon.src} alt="" width={17} height={17} aria-hidden="true" />;
}} data-sentry-element="ToastContainer" data-sentry-component="ToastV4Container" data-sentry-source-file="ToastV4Container.tsx" />;
export default ToastV4Container;